'use client';

import React, { createContext, useContext, ReactNode } from 'react';
import { useAuth, UseAuthReturn, UseAuthOptions } from '@hooks/useAuth';

const AuthContext = createContext<UseAuthReturn | null>(null);

export function AuthProvider({ 
  children, 
  authOptions
}: { 
  children: ReactNode, 
  authOptions?: UseAuthOptions 
}) {
  // Single useAuth call at the app root
  const auth = useAuth(authOptions);
  
  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

// Custom hook for consuming the auth context
export function useAuthContext(): UseAuthReturn {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
} 